import { useFeedbackPrompt } from 'hooks/use-feedback-prompt'

import { ProductFeedbackModal } from './product-feedback-modal'

interface PostTestProductFeedbackProps {
  finished: number | false
  wpmCalculatedAt: number
}

/**
 * Shows the three-day product feedback prompt after a completed typing test when eligible.
 */
export const PostTestProductFeedback = ({ finished, wpmCalculatedAt }: PostTestProductFeedbackProps) => {
  const { isVisible, handleSubmit, handleAskMeLater, handleDismissForever } = useFeedbackPrompt({
    finished,
    wpmCalculatedAt,
  })

  if (!isVisible) return null

  return (
    <ProductFeedbackModal
      isOpen={isVisible}
      onSubmit={handleSubmit}
      onAskMeLater={handleAskMeLater}
      onDismissForever={handleDismissForever}
    />
  )
}
